import { ThemeSwitch } from './ThemeSwitch'
import { withThemeSwitch } from './withThemeSwitch'

const ConnectedThemeSwitch = withThemeSwitch(ThemeSwitch)

export { ConnectedThemeSwitch as ThemeSwitch }
